module.exports = __webpack_public_path__ + "media/images/apple_health/watch/bft-866e839388abd28c8f1059eb39c7dd23.svg";